import React from "react";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";
import { App } from "./app";

const reRender = Comp => {
  return render(
    <AppContainer>
      <Comp />
    </AppContainer>,
    document.getElementById("root")
  );
};

reRender(App);

if (module && module.hot) {
  module.hot.accept("./app", () => reRender(App));
}
